import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { Badge, Button, message, notification, Popconfirm } from 'antd';
import async from 'async';
import PropTypes from 'prop-types';
import CommonTable from '../../components/CommonTable';
import EllipsisTooltip from '../../components/EllipsisTooltip';
import { ROLES, VARIOUS_CLIENTS_CLIENT_ID } from '../../constants/global';
import {
	getactionMessages,
	getClientMessages,
	getErrorMessages,
	getInvoicingMessages,
	getLanguageIntl,
	getModalMessages,
	getPopConfirm,
	getProformaMessages,
	getQuotationMessages,
} from '../../constants/messages';
import { roundN } from '../../utilities/util';
import AddUpdateModal from '../Clients/AddOrUpdate/FormModal';
import { EditFiscalData, GetFiscalData } from '../FiscalData/actions';
import { AddInvoice, GetClientsPendingInvoices, GetLatestPayment, PrintInvoice } from '../Invoices/actions';
import AddObservationsModal from '../Invoices/AddObservationsModal';
import PopoverProductsTable from '../Invoices/PopoverProductsTable';
import { GetProductsOfQuotation } from '../Products/actions';
import { AddProforma, SetProformaToInvoiced } from '../Proformas/actions';
import {
	ApproveQuotation,
	CheckExpiredQuotations,
	GetQuotation,
	GetQuotations,
	RenewQuotation,
	SearchQuotations,
	SearchQuotationsBySalesPerson,
	SetQuotationToInvoiced,
	SetQuotationToProforma,
} from './actions';
import { STATUSES } from './constants';
import DenyQuotationModal from './DenyQuotationModal';
import QuotationFilter from './QuotationFilter';
const { NEEDS_APPROVAL, INVOICED, DENIED, CREATED_PROFORMA, EXPIRED } = STATUSES;

let moment = require('moment');

let quotationMessages = getQuotationMessages(),
	errorMessages = getErrorMessages(),
	actionMessages = getactionMessages(),
	modalMessages = getModalMessages(),
	languageMessages = getLanguageIntl(),
	invoicingMessages = getInvoicingMessages(),
	proformaMessages = getProformaMessages(),
	popconfirmMessages = getPopConfirm(),
	clientMessages = getClientMessages();

const messages = {
	...quotationMessages,
	...modalMessages,
	...actionMessages,
	...errorMessages,
	...languageMessages,
	...invoicingMessages,
	...proformaMessages,
	...popconfirmMessages,
	...clientMessages,
};

const defaultAddObservationsProps = {
	showAddObservationsModal: false,
	addObservationsHandleSubmit: () => {},
	addObservationsTitle: '',
	addObservationsSaveButtonText: '',
	addObservationsCurrentObservations: '',
};

class Quotations extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			selectedQuotation: 0,
			showModal: false,
			quotationId: 0,
			showAddClientModal: false,
			newClientInfo: {},
			...defaultAddObservationsProps,
		};
	}

	componentDidMount() {
		this.props.getFiscalData();
	}

	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	getQuotations = (page, pageSize) => {
		this.setState({ isLoading: true });
		this.props
			.getQuotations(page, pageSize)
			.then(() => {
				this.setState({
					isLoading: false,
				});
			})
			.catch(() => {
				message.error(`${this.props.intl.formatMessage({ ...messages.GetQuotationsError })}`);
				this.setState({
					isLoading: false,
				});
			});
	};

	searchQuotations = (page, pageSize, search) => {
		const { searchQuotations, searchQuotationsBySeller } = this.props;
		this.setState({ isLoading: true });
		const isSalesPerson = this.props.roles.includes(ROLES.SALES);
		const searchFunc = isSalesPerson ? searchQuotationsBySeller : searchQuotations;
		searchFunc(page, pageSize, search)
			.then(() => {
				this.setState({ isLoading: false });
			})
			.catch(() => {
				message.error(`${this.props.intl.formatMessage({ ...messages.GetQuotationsError })}`);
				this.setState({ isLoading: false });
			});
	};

	padWithZeroes = (number) => {
		let my_string = '' + number;
		while (my_string.length < 8) {
			my_string = '0' + my_string;
		}

		return my_string;
	};

	navigate = () => {
		this.props.history.push(`/quotations/new`);
	};

	SearchQuotations = (search) => {
		this.setState({
			isLoading: true,
		});
		this.props
			.searchQuotations(search)
			.then(() => {
				this.setState({
					isLoading: false,
				});
			})
			.catch(() => {
				message.error(`${this.props.intl.formatMessage({ ...messages.GetQuotationsError })}`);
				this.setState({
					isLoading: false,
				});
			});
	};

	openDenyModal = (id) => {
		this.setState({
			selectedQuotation: id,
			showModal: true,
		});
	};

	closeDenyModal = () => {
		this.setState({
			showModal: false,
		});
	};

	approveQuotation = (id) => {
		this.props
			.approveQuotation(id)
			.then(() => {
				this.props.getQuotations().catch(() => {
					message.error(`${this.props.intl.formatMessage({ ...messages.GetQuotationsError })}`);
				});
			})
			.catch(() => {
				message.error(`${this.props.intl.formatMessage({ ...messages.ApproveQuotationError })}`);
			});
	};

	renewQuotation = (id) => {
		this.props
			.renewQuotation(id)
			.then(() => {
				this.props.getQuotations().catch(() => {
					message.error(`${this.props.intl.formatMessage({ ...messages.GetQuotationsError })}`);
				});
			})
			.catch(() => {
				message.error(`${this.props.intl.formatMessage({ ...messages.ApproveQuotationError })}`);
			});
	};

	createInvoice = (quotation) => {
		this.setState({ isLoading: true });
		const tasks = [
			(cb) =>
				this.props
					.getProductsOfQuotation(quotation.id)
					.then(() => cb(null))
					.catch(cb),
			(cb) =>
				this.props
					.getFiscalData()
					.then(() => cb(null))
					.catch(cb),
		];
		async.parallel(tasks, (err) => {
			if (err) {
				message.error(`${this.props.intl.formatMessage({ ...messages.AddInvoiceError })}`);
				this.setState({ isLoading: false });
				return;
			}
			let values = {
				clientId: quotation.clientId,
				accountId: this.props.user.id,
				cai: this.props.fiscalData.invoice.cai,
				InitialRValue: this.props.fiscalData.invoice.initialRValue.toString(),
				FinalRValue: this.props.fiscalData.invoice.finalRValue.toString(),
				documentNumber:
					this.props.fiscalData.invoice.prefix +
					'-' +
					this.padWithZeroes(this.props.fiscalData.invoice.currentRValue),
				fiscalExpiryDate: this.props.fiscalData.invoice.expiryDate,
				status: 0,
				total: quotation.total,
				createdAt: moment(),
				paymentDate: quotation.type === 2 ? moment().add(quotation.daysForPayment, 'days') : moment(),
				type: quotation.type,
				observations: quotation.observations,
				exchangeRate: quotation.exchangeRate,
				reasonAnullment: '',
				clientRtn: quotation.clientRtn,
				clientName: quotation.clientName,
				representative: quotation.representative,
				products: this.props.productsOfQuotation,
				amount: 0,
				lastDocNum: '',
				address: quotation.address,
				city: quotation.city,
				state: quotation.state,
			};
			this.props.getClientsPendingInvoices(values.clientId).then(() => {
				this.props
					.getLatestPayment(values.clientId)
					.then(() => {
						if (
							this.props.latestPayment.balance < 0 &&
							values.clientId !== 1 &&
							this.props.pendingInvoices.length === 0
						) {
							let description = this.props.latestPayment.description;
							if (description === null) {
								description = 'Abonado a factura número ' + values.documentNumber + '.';
							} else {
								description += ' Abonado a factura número ' + values.documentNumber + '.';
							}
							values = {
								...values,
								amount: this.props.latestPayment.balance,
								newDesc: description,
								paymentId: this.props.latestPayment.id,
								lastDocNum: this.props.lastDocNum,
							};
						}
						this.props
							.addInvoice(values)
							.then(() => {
								if (this.props.addedInvoice) {
									let fiscalData = {
										...this.props.fiscalData.invoice,
										currentRValue: this.props.fiscalData.invoice.currentRValue + 1,
									};
									this.props.editFiscalData(fiscalData).then(() => {
										this.props.printInvoice([this.props.invoice.id]).catch(() => {
											message.error(
												`${this.props.intl.formatMessage({ ...messages.PrintError })}`
											);
										});
										let { id, ...proforma } = quotation;
										proforma = {
											...proforma,
											products: this.props.productsOfQuotation,
											status: 2,
											invoiceId: this.props.invoice.id,
											taxExemption: false,
											isProgrammed: false,
											dateProgrammed: moment(),
											quotationId: quotation.id,
										};
										if (quotation.status !== 4) {
											this.props
												.addProforma(proforma)
												.then(() => {
													this.props
														.setQuotationToInvoiced(
															id,
															this.props.invoice.id,
															this.props.proforma.id
														)
														.catch(() => {
															message.error(
																`${this.props.intl.formatMessage({ ...messages.AddProformaError })}`
															);
														});
													notification.open({
														message: this.props.intl.formatMessage({ ...messages.Print }),
														description: this.props.intl.formatMessage({
															...messages.ReminderPrint,
														}),
													});
													this.setState({
														isLoading: false,
													});
													this.props.history.push(`/invoices/${this.props.invoice.id}`);
												})
												.catch(() => {
													message.error(
														`${this.props.intl.formatMessage({ ...messages.AddProformaError })}`
													);
													this.setState({
														isLoading: false,
													});
												});
										} else {
											this.props
												.setProformaToInvoiced(quotation.proformaId, this.props.invoice.id)
												.then(() => {
													this.props
														.setQuotationToInvoiced(
															id,
															this.props.invoice.id,
															this.props.proforma.id
														)
														.catch(() => {
															message.error(
																`${this.props.intl.formatMessage({ ...messages.SetQuotationAsInvoicedError })}`
															);
														});
													notification.open({
														message: this.props.intl.formatMessage({ ...messages.Print }),
														description: this.props.intl.formatMessage({
															...messages.ReminderPrint,
														}),
													});
													this.setState({
														isLoading: false,
													});
													this.props.history.push(`/invoices/${this.props.invoice.id}`);
												})
												.catch(() => {
													message.error(
														`${this.props.intl.formatMessage({ ...messages.SetProformaAsInvoicedError })}`
													);
													this.setState({
														isLoading: false,
													});
												});
										}
									});
								}
							})
							.catch(() => {
								message.error(`${this.props.intl.formatMessage({ ...messages.AddInvoiceError })}`);
								this.setState({
									isLoading: false,
								});
							});
					})
					.catch(() => {
						message.error(`${this.props.intl.formatMessage({ ...messages.GetLatestPaymentError })}`);
						this.setState({
							isLoading: false,
						});
					});
			});
		});
	};

	createProforma = (quotation) => {
		this.setState({
			isLoading: true,
		});
		let { id, ...proforma } = quotation;
		this.props.getProductsOfQuotation(quotation.id).then(() => {
			proforma = {
				...proforma,
				products: this.props.productsOfQuotation,
				taxExemption: quotation.taxExemption,
				isProgrammed: false,
				dateProgrammed: moment(),
				quotationId: quotation.id,
			};
			this.props
				.addProforma(proforma)
				.then(() => {
					this.props.setQuotationToProforma(id, this.props.proforma.id).catch(() => {
						message.error(`${this.props.intl.formatMessage({ ...messages.SetQuotationToProformaError })}`);
					});
					this.setState({
						isLoading: false,
					});
					this.props.history.push(`/proformas/${this.props.proforma.id}`);
				})
				.catch(() => {
					message.error(`${this.props.intl.formatMessage({ ...messages.AddProformaError })}`);
					this.setState({
						isLoading: false,
					});
				});
		});
	};

	openAddObservationsModalProforma = (quotation) => {
		const { getIntl, createProforma } = this;
		const { observations } = quotation;
		const showAddObservationsModal = true;
		const addObservationsTitle = getIntl('ToProforma');
		const addObservationsSaveButtonText = getIntl('ToProforma');
		const addObservationsCurrentObservations = observations;
		const addObservationsHandleSubmit = (newObservations) => {
			const quotationCopy = {
				...quotation,
				observations: newObservations,
			};
			createProforma(quotationCopy);
		};
		this.setState({
			showAddObservationsModal,
			addObservationsTitle,
			addObservationsSaveButtonText,
			addObservationsCurrentObservations,
			addObservationsHandleSubmit,
		});
	};

	openAddObservationsModalInvoice = (quotation) => {
		const { getIntl, createInvoice } = this;
		const { observations } = quotation;
		const showAddObservationsModal = true;
		const addObservationsTitle = getIntl('Invoice');
		const addObservationsSaveButtonText = getIntl('Invoice');
		const addObservationsCurrentObservations = observations;
		const addObservationsHandleSubmit = (newObservations) => {
			const quotationCopy = {
				...quotation,
				observations: newObservations,
			};
			createInvoice(quotationCopy);
		};
		this.setState({
			showAddObservationsModal,
			addObservationsTitle,
			addObservationsSaveButtonText,
			addObservationsCurrentObservations,
			addObservationsHandleSubmit,
		});
	};

	closeAddObservationsModal = () => {
		this.setState({ ...defaultAddObservationsProps });
	};

	createNewClientModal = (quotation) => {
		this.setState({
			showAddClientModal: true,
			newClientInfo: {
				name: quotation.clientName,
				representative: quotation.representative,
				rtn: quotation.clientRtn,
				address: {
					state: quotation.state,
					city: quotation.city,
					address: quotation.address,
				},
			},
			quotationId: quotation.id,
		});
	};

	render() {
		const {
			state,
			props,
			closeAddObservationsModal,
			openAddObservationsModalProforma,
			openAddObservationsModalInvoice,
		} = this;
		const {
			quotationId,
			showAddObservationsModal,
			isLoading,
			addObservationsCurrentObservations,
			addObservationsHandleSubmit,
			addObservationsTitle,
			addObservationsSaveButtonText,
			showAddClientModal,
			newClientInfo,
		} = state;
		const { searchText, currentPage, isMaster, history, intl } = props;
		const onQuotationNumberClick = (e, quotationId) => {
			e.preventDefault();
			history.push(`/quotations/${quotationId}`);
		};
		let addQuotationButton = (
			<span>
				<Button type="primary" onClick={this.navigate}>
					<PlusOutlined />
					<FormattedMessage {...messages.add} />
				</Button>
			</span>
		);

		let columns = [
			{
				title: intl.formatMessage({ ...messages.QuotationNumber }),
				dataIndex: 'id',
				key: 'id',
				width: 200,
				render: (quotationId, quotation) => {
					const { quotationProducts = [] } = quotation;
					return (
						<PopoverProductsTable products={quotationProducts}>
							<a
								href={`/quotations/${quotationId}`}
								onClick={(e) => onQuotationNumberClick(e, quotationId)}
							>
								{quotationId}
							</a>
						</PopoverProductsTable>
					);
				},
			},
			{
				title: intl.formatMessage({ ...messages.Client }),
				dataIndex: 'clientName',
				key: 'clientName',
				width: 250,
				onCell: () => {
					return {
						style: {
							whiteSpace: 'nowrap',
							maxWidth: 250,
						},
					};
				},
				render: (clientName) => {
					return <EllipsisTooltip title={clientName}>{clientName}</EllipsisTooltip>;
				},
			},
			{
				title: intl.formatMessage({ ...messages.Type }),
				dataIndex: 'type',
				key: 'type',
				width: 100,
				render: (type) => {
					if (type === 1) {
						return intl.formatMessage({ ...messages.Cash });
					} else if (type === 2) {
						return intl.formatMessage({ ...messages.Credit });
					}
				},
			},
			{
				title: intl.formatMessage({ ...messages.Status }),
				dataIndex: 'status',
				className: 'status',
				width: 150,
				render: (status) => {
					let color = 'processing';
					let text = intl.formatMessage({ ...messages.ReadyInvoicing });
					if (status === NEEDS_APPROVAL) {
						color = 'warning';
						text = intl.formatMessage({ ...messages.NeedsApproval });
					} else if (status === INVOICED) {
						color = 'success';
						text = intl.formatMessage({ ...messages.Invoiced });
					} else if (status === DENIED) {
						color = 'error';
						text = intl.formatMessage({ ...messages.Denied });
					} else if (status === CREATED_PROFORMA) {
						color = 'success';
						text = intl.formatMessage({ ...messages.CreatedProforma });
					} else if (status === EXPIRED) {
						color = 'error';
						text = intl.formatMessage({ ...messages.Expired });
					}
					return <Badge status={color} text={text} />;
				},
			},
			{
				title: intl.formatMessage({ ...messages.Total }),
				dataIndex: 'total',
				key: 'total',
				className: 'column-money',
				width: 250,
				render: (total, quotation) => {
					return `L ${roundN(total * quotation.exchangeRate, 2)}`;
				},
			},
			{
				title: intl.formatMessage({ ...messages.Date }),
				dataIndex: 'createdAt',
				key: 'createdAt',
				width: 250,
				render: (date) => {
					let formatedDate = new Date(date);
					formatedDate.toLocaleDateString();
					return formatedDate.toLocaleDateString(intl.formatMessage({ ...messages.intl }), {
						weekday: 'long',
						year: 'numeric',
						month: 'long',
						day: 'numeric',
					});
				},
			},
			{
				title: intl.formatMessage({ ...messages.Actions }),
				dataIndex: 'id',
				key: 'actions',
				render: (id, quotation) => {
					const { roles } = this.props;
					const isSalesPerson = roles.includes(ROLES.SALES);
					return (
						<span>
							<a
								onClick={() => {
									history.push(`/quotations/${id}`);
								}}
							>
								{' '}
								<FormattedMessage {...messages.View} />{' '}
							</a>
							{quotation.status === 0 && (
								<span>
									{(isMaster || roles.includes(ROLES.ADMINISTRATOR)) && !isSalesPerson && (
										<span>
											<span> | </span>
											<a
												onClick={() => {
													openAddObservationsModalProforma(quotation);
												}}
											>
												{' '}
												<FormattedMessage {...messages.ToProforma} />{' '}
											</a>
											<span> | </span>
											<a
												onClick={() => {
													openAddObservationsModalInvoice(quotation);
												}}
											>
												{' '}
												<FormattedMessage {...messages.Invoice} />{' '}
											</a>
										</span>
									)}
									{quotation.clientId === VARIOUS_CLIENTS_CLIENT_ID &&
										(isMaster || isSalesPerson || roles.includes(ROLES.ADMINISTRATOR)) && (
											<span>
												<span> | </span>
												<a
													onClick={() => {
														this.createNewClientModal(quotation);
													}}
												>
													{' '}
													<FormattedMessage {...messages.addClient} />
												</a>
											</span>
										)}
								</span>
							)}
							{quotation.status === 1 && isMaster && !isSalesPerson && (
								<span>
									<span> | </span>
									<Popconfirm
										title={intl.formatMessage({ ...messages.ApproveQ })}
										okText={intl.formatMessage({ ...messages.yes })}
										cancelText={intl.formatMessage({ ...messages.no })}
										onConfirm={() => {
											this.approveQuotation(id);
										}}
									>
										<a href="#">
											<FormattedMessage {...messages.Approve} />
										</a>
									</Popconfirm>
									<span> | </span>
									<a
										onClick={() => {
											this.openDenyModal(id);
										}}
									>
										{' '}
										<FormattedMessage {...messages.Deny} />{' '}
									</a>
								</span>
							)}
							{quotation.status === 2 &&
								(isMaster || roles.includes(ROLES.ADMINISTRATOR)) &&
								!isSalesPerson && (
									<span>
										<span> | </span>
										<a
											onClick={() => {
												history.push(`/invoices/${quotation.invoiceId}`);
											}}
										>
											{' '}
											<FormattedMessage {...messages.ViewInvoice} />{' '}
										</a>
										<span> | </span>
										<a
											onClick={() => {
												history.push(`/proformas/${quotation.proformaId}`);
											}}
										>
											{' '}
											<FormattedMessage {...messages.ViewProforma} />{' '}
										</a>
									</span>
								)}
							{quotation.status === 4 &&
								(isMaster || roles.includes(ROLES.ADMINISTRATOR)) &&
								!isSalesPerson && (
									<span>
										<span> | </span>
										<a
											onClick={() => {
												history.push(`/proformas/${quotation.proformaId}`);
											}}
										>
											{' '}
											<FormattedMessage {...messages.ViewProforma} />{' '}
										</a>
										<span> | </span>
										<a
											onClick={() => {
												openAddObservationsModalInvoice(quotation);
											}}
										>
											{' '}
											<FormattedMessage {...messages.Invoice} />{' '}
										</a>
									</span>
								)}
							{quotation.status === 5 && (
								<span>
									<span> | </span>
									<Popconfirm
										title={intl.formatMessage({ ...messages.RenewQ })}
										okText={intl.formatMessage({ ...messages.yes })}
										cancelText={intl.formatMessage({ ...messages.no })}
										onConfirm={() => {
											this.renewQuotation(id);
										}}
									>
										<a href="#">
											<FormattedMessage {...messages.Renew} />
										</a>
									</Popconfirm>
								</span>
							)}
						</span>
					);
				},
			},
		];

		return (
			<div className="account view">
				<DenyQuotationModal
					quotationId={this.state.selectedQuotation}
					showModal={this.state.showModal}
					closeDenyModal={this.closeDenyModal}
				/>
				<AddUpdateModal
					isUpdate={false}
					quotationId={quotationId}
					clientInfo={newClientInfo}
					showModal={showAddClientModal}
					handleCancel={() => {
						this.setState({ showAddClientModal: false, quotationId: 0 });
					}}
				/>
				<AddObservationsModal
					showModal={showAddObservationsModal}
					isLoading={isLoading}
					handleSubmit={addObservationsHandleSubmit}
					handleCancel={closeAddObservationsModal}
					title={addObservationsTitle}
					saveButtonText={addObservationsSaveButtonText}
					currentObservations={addObservationsCurrentObservations}
				/>
				<CommonTable
					columns={columns}
					dataSource={this.props.quotations}
					search={(search, page, pageSize) => this.searchQuotations(page, pageSize, search)}
					searchText={searchText}
					currentPage={currentPage}
					recordCount={this.props.count}
					preservePage={true}
					getRecords={(page, pageSize) => this.getQuotations(page, pageSize)}
					Add={addQuotationButton}
					loading={this.state.isLoading}
					filterComponent={<QuotationFilter />}
					getCheckboxProps={() => ({ disabled: false })}
					hideCheckboxes
				/>
			</div>
		);
	}
}

Quotations.propTypes = {
	intl: PropTypes.object.isRequired,
	user: PropTypes.object.isRequired,
	isMaster: PropTypes.bool.isRequired,
	roles: PropTypes.array.isRequired,
	productsOfQuotation: PropTypes.array.isRequired,
	latestPayment: PropTypes.object.isRequired,
	invoice: PropTypes.object.isRequired,
	addedInvoice: PropTypes.bool.isRequired,
	lastDocNum: PropTypes.string.isRequired,
	quotations: PropTypes.array.isRequired,
	fiscalData: PropTypes.object.isRequired,
	proforma: PropTypes.object.isRequired,
	pendingInvoices: PropTypes.array.isRequired,
	getQuotations: PropTypes.func.isRequired,
	getQuotation: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	searchQuotations: PropTypes.func.isRequired,
	searchQuotationsBySeller: PropTypes.func.isRequired,
	approveQuotation: PropTypes.func.isRequired,
	setQuotationToInvoiced: PropTypes.func.isRequired,
	setQuotationToProforma: PropTypes.func.isRequired,
	getProductsOfQuotation: PropTypes.func.isRequired,
	getFiscalData: PropTypes.func.isRequired,
	editFiscalData: PropTypes.func.isRequired,
	getLatestPayment: PropTypes.func.isRequired,
	addInvoice: PropTypes.func.isRequired,
	printInvoice: PropTypes.func.isRequired,
	addProforma: PropTypes.func.isRequired,
	getClientsPendingInvoices: PropTypes.func.isRequired,
	renewQuotation: PropTypes.func.isRequired,
	setProformaToInvoiced: PropTypes.func.isRequired,
	count: PropTypes.number.isRequired,
	searchText: PropTypes.string,
	currentPage: PropTypes.number,
};

const mapStateToProps = (state) => {
	return {
		quotations: state.quotation.quotations,
		user: state.auth.user,
		isMaster: state.auth.isMaster,
		roles: state.auth.roles,
		productsOfQuotation: state.product.productsOfCurrentQuotation,
		fiscalData: state.fiscalData.fiscalData,
		latestPayment: state.invoicing.latestPayment,
		invoice: state.invoicing.invoice,
		addedInvoice: state.invoicing.addedInvoice,
		lastDocNum: state.invoicing.lastDocNum,
		proforma: state.proforma.proforma,
		pendingInvoices: state.invoicing.pendingInvoices,
		searchText: state.quotation.search,
		count: state.quotation.count,
		currentPage: state.quotation.page,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getQuotations: (page, pageSize) => {
			return dispatch(GetQuotations(page, pageSize));
		},
		getQuotation: (id) => {
			return dispatch(GetQuotation(id));
		},
		searchQuotations: (page, pageSize, search) => {
			return dispatch(SearchQuotations(page, pageSize, search));
		},
		searchQuotationsBySeller: (page, pageSize, search) => {
			return dispatch(SearchQuotationsBySalesPerson(page, pageSize, search));
		},
		approveQuotation: (id) => {
			return dispatch(ApproveQuotation(id));
		},
		checkExpiredQuotations: () => {
			return dispatch(CheckExpiredQuotations());
		},
		renewQuotation: (id) => {
			return dispatch(RenewQuotation(id));
		},
		setQuotationToInvoiced: (id, invoiceId, proformaId) => {
			return dispatch(SetQuotationToInvoiced(id, invoiceId, proformaId));
		},
		setQuotationToProforma: (id, proformaId) => {
			return dispatch(SetQuotationToProforma(id, proformaId));
		},
		getProductsOfQuotation: (id) => {
			return dispatch(GetProductsOfQuotation(id));
		},
		getFiscalData: () => {
			return dispatch(GetFiscalData());
		},
		editFiscalData: (fiscalData) => {
			return dispatch(EditFiscalData(fiscalData));
		},
		getLatestPayment: (clientId) => {
			return dispatch(GetLatestPayment(clientId));
		},
		addInvoice: (newInvoice) => {
			return dispatch(AddInvoice(newInvoice));
		},
		printInvoice: (ids) => {
			return dispatch(PrintInvoice(ids));
		},
		getClientsPendingInvoices: (clientId) => {
			return dispatch(GetClientsPendingInvoices(clientId));
		},
		addProforma: (newProforma) => {
			return dispatch(AddProforma(newProforma));
		},
		setProformaToInvoiced: (id, invoiceId) => {
			return dispatch(SetProformaToInvoiced(id, invoiceId));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Quotations)));
